import axios from 'axios'

import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,
    RESET_PASSWORD_CONFIRM_SUCCESS,
    RESET_PASSWORD_CONFIRM_FAIL,
    SET_AUTH_LOADING,
    REMOVE_AUTH_LOADING,
    LOGOUT,
    LOGOUT_FAIL,
    REGISTER_COMPLETE,
    REGISTER_FAIL,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    REFRESH_SUCCESS,
    REFRESH_FAIL,
    RESEND_ACTIVATION_SUCCESS,
    RESEND_ACTIVATION_FAIL,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    ACTIVATION_SUCCESS,
    ACTIVATION_FAIL,
    GET_USER_PROFILE_FAIL,
    GET_USER_PROFILE_SUCCESS,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_FAIL
} from './types'

export const create = (email, password) => async dispatch =>{

    dispatch({
        type: SET_AUTH_LOADING
    });
    
    const config = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        withCredentials: true
    };

    const body = JSON.stringify({
        email,
        password
    });

    try{

        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/jwt/create/`, body, config)

        if(res.status === 200){
            dispatch({
                type: LOGIN_SUCCESS,
                payload: res.data
            });

            dispatch({
                type: REMOVE_AUTH_LOADING
            });
        }else{
            dispatch({
                type: LOGIN_FAIL,
            });
            
            dispatch({
                type: REMOVE_AUTH_LOADING
            });
        }

    }catch(err){
        dispatch({
            type: LOGIN_FAIL,
        });
        
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
    }
}

export const verify = () => async dispatch =>{

    if(localStorage.getItem('access')){
        
        const config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
    
        const body = JSON.stringify({
            token: localStorage.getItem('access')
        });

        try{

            const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/jwt/verify/`, body, config)

            if(res.status === 200){
                dispatch({
                    type: AUTHENTICATED_SUCCESS
                })
            }else{
                dispatch({
                    type: AUTHENTICATED_FAIL
                });
            }
        }catch(err){
            dispatch({
                type: AUTHENTICATED_FAIL
            });
        }
    }else{
        dispatch({
            type: AUTHENTICATED_FAIL
        });
    }
}

export const refresh = () => async dispatch =>{

    const config = {
        headers: {
            'Accept': 'application/json',
        },
    };

    try{

        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/jwt/refresh/`, config)

        if(res.status === 200){
            dispatch({
                type: REFRESH_SUCCESS,
                payload: res.data
            })
        }else{
            dispatch({
                type: REFRESH_FAIL
            });
        }
    }catch(err){
        dispatch({
            type: REFRESH_FAIL
        });
    }
}

export const reset_password = (email) => async dispatch => {
    dispatch({
        type: SET_AUTH_LOADING
    });

    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ email });

    try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/reset_password/`, body, config);

        if (res.status === 204) {
            dispatch({
                type: RESET_PASSWORD_SUCCESS
            });
            
            dispatch({
                type: REMOVE_AUTH_LOADING
            });
        } else {
            dispatch({
                type: RESET_PASSWORD_FAIL
            });
            dispatch({
                type: REMOVE_AUTH_LOADING
            });
            
        }
    } catch (err) {
        dispatch({
            type: RESET_PASSWORD_FAIL
        });
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
        
    }
}

export const reset_password_confirm = (uid, token, new_password, re_new_password) => async dispatch => {
    dispatch({
        type: SET_AUTH_LOADING
    });

    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        uid,
        token,
        new_password,
        re_new_password
    });

    if (new_password !== re_new_password) {
        dispatch({
            type: RESET_PASSWORD_CONFIRM_FAIL
        });
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
        
    } else {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/reset_password_confirm/`, body, config);

            if (res.status === 204) {
                dispatch({
                    type: RESET_PASSWORD_CONFIRM_SUCCESS
                });
                dispatch({
                    type: REMOVE_AUTH_LOADING
                });
                
            } else {
                dispatch({
                    type: RESET_PASSWORD_CONFIRM_FAIL
                });
                dispatch({
                    type: REMOVE_AUTH_LOADING
                });
            }
        } catch (err) {
            dispatch({
                type: RESET_PASSWORD_CONFIRM_FAIL,
                payload: err.response?.data?.new_password?.[0]
            });
            dispatch({
                type: REMOVE_AUTH_LOADING
            });
        }
    }
}

export const register = (email, password, re_password) => async dispatch =>{
    
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
    };

    const body = JSON.stringify({
        email,
        password,
        re_password,
    });

    if (password !== re_password) {
        dispatch({
            type: REGISTER_FAIL
        });
        
    } else {

        try{

            const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/`, body, config)
            if(res.status === 201){
                dispatch({
                    type: REGISTER_COMPLETE,
                });

            }else{
                dispatch({
                    type: REGISTER_FAIL,
                });
            }

        }catch(err){
            dispatch({
                type: REGISTER_FAIL,
                payload: err.response?.data?.password?.[0]
            });
        }
    }
}

export const resend_activation = (email) => async dispatch => {
   
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ email });

    try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/resend_activation/`, body, config);

        if (res.status === 200) {
            dispatch({
                type: RESEND_ACTIVATION_SUCCESS
            });
            
        } else {
            dispatch({
                type: RESEND_ACTIVATION_FAIL
            });
        }
    } catch (err) {
        dispatch({
            type: RESEND_ACTIVATION_FAIL
        });    
    }
}

export const activate = (uid, token) => async dispatch => {
    
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ 
        uid,
        token,
     });

    try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/activation/`, body, config);

        if (res.status === 200) {
            dispatch({
                type: ACTIVATION_SUCCESS
            });
            
        } else {
            dispatch({
                type: ACTIVATION_FAIL
            });
        }
    } catch (err) {
        dispatch({
            type: ACTIVATION_FAIL
        });    
    }
}

export const logout = () => async dispatch => {

    const config = {
        headers: {
            'Accept': 'application/json',
        },
    };

    try{

        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/logout/`, config)

        if(res.status === 200){
            dispatch({
                type: LOGOUT,
            })
        }else{
            dispatch({
                type: LOGOUT_FAIL
            });
        }
    }catch(err){
        dispatch({
            type: LOGOUT_FAIL
        });
    }
};

export const load_user = () => async dispatch => {
    if (localStorage.getItem('access')) {

        const config = {
            headers: {
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        };

        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/users/me/`, config);

            if (res.status === 200) {
                dispatch({
                    type: USER_LOADED_SUCCESS,
                    payload: res.data
                });
            } else {
                dispatch({
                    type: USER_LOADED_FAIL
                });
            }
        } catch (err) {
            dispatch({
                type: USER_LOADED_FAIL
            });
        }
    } else {
        dispatch({
            type: USER_LOADED_FAIL
        });
    }
};

export const get_profile = (slug) => async dispatch => {

    const config = {
        headers: {
            'Accept': 'application/json'
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/profile/${slug}`, config);

        if (res.status === 200) {
            dispatch({
                type: GET_USER_PROFILE_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_USER_PROFILE_FAIL
            });
        }
    } catch (err) {
        dispatch({
            type: GET_USER_PROFILE_FAIL
        });
    }

 
};

export const update_profile = (data) => async dispatch => {

    if (localStorage.getItem('access')) {

        const body = data;

        const config = {
            headers: {
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        };

        try {
            const res = await axios.patch(`${process.env.REACT_APP_API_URL}/auth/editprofile/`, body, config);

            if (res.status === 200) {
                dispatch({
                    type: USER_UPDATE_SUCCESS,
                });
            } else {
                dispatch({
                    type: USER_UPDATE_FAIL
                });
            }
        } catch (err) {
            dispatch({
                type: USER_UPDATE_FAIL
            });
        }
    } else {
        dispatch({
            type: USER_UPDATE_FAIL
        });
    }

 
};